<template>
    <div class="w-100 h-100 d-flex flex-column">
        <!-- Internal note -->
        <div v-if="canSeeInternalNote" class="d-flex flex-column flex-grow-1">
            <label>
                <span v-if="hasInternalNote" class="reservation__notes--red-dot"></span>
                Internal notes:<span class="fs-smaller normal ml-1">(internal use only)</span>
            </label>

            <textarea
                :disabled="disabled || !canEditInternalNote"
                @input="() => markFlagDirty('internalNote')"
                v-model="reservation.internalNote"
                class="flex-grow-1 p-1 fs-bigger bg-lighter darker bold"
                rows="1">
            </textarea>
        </div>

        <!-- Public note -->
        <div class="d-flex flex-column flex-grow-1 mt-2">
            <label>
                <span v-if="hasNotes" class="reservation__notes--red-dot"></span>
                Notes:<span class="fs-smaller normal ml-1">(agents can see these)</span>
            </label>

            <textarea
                :disabled="disabled"
                @input="() => markFlagDirty('customer')"
                v-model="reservation.note"
                class="flex-grow-1 p-1 fs-bigger bg-lighter darker bold"
                rows="1">
            </textarea>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props:{
            reservation: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        created() {
            if (!this.reservation) return;

            if (!this.reservation.updateFlags) {
                this.$set(this.reservation, 'updateFlags', {});
            }
        },
        computed: {
            ...mapGetters([
                'getCanReadInternalNote',
                'getCanEditInternalNote'
            ]),
            hasNotes() {
                return !!(this.reservation.note && this.reservation.note.length > 0);
            },
            hasInternalNote() {
                return !!(this.reservation.internalNote && this.reservation.internalNote.length > 0);
            },
            canSeeInternalNote() {
                return this.getCanReadInternalNote;
            },
            canEditInternalNote() {
                return this.getCanEditInternalNote;
            }
        },
        methods: {
            markFlagDirty(flag) {
                if (!this.reservation.updateFlags) {
                    this.$set(this.reservation, 'updateFlags', {});
                }

                this.$set(this.reservation.updateFlags, flag, true);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/_variables.scss";

    .reservation__notes--red-dot {
        background-color: #f16c64;
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        margin-bottom: 4px;
        margin-right: 5px;
    }
</style>



// WEBPACK FOOTER //
// Notes.vue?7087490a